"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllMetadata = exports.fetchImportMap = exports.getImportMapOverrides = void 0;
const url_resolver_1 = require("./url-resolver");
const getImportMapOverrides = () => window.importMapOverrides.getOverrideMap();
exports.getImportMapOverrides = getImportMapOverrides;
async function fetchImportMap() {
    const response = await fetch("/importmap.json");
    return await response.json();
}
exports.fetchImportMap = fetchImportMap;
/**
 * Fetches the all available metadata of the micro frontends.
 * If fetching the metadata failed, the metadata is not contained in the result.
 * @returns never rejects
 */
async function fetchAllMetadata() {
    const importMap = await fetchImportMap().catch(() => ({ imports: {} }));
    if (!importMap.imports)
        return [];
    const promises = [];
    for (const mfUrl of Object.values(importMap.imports)) {
        promises.push(fetchMetadata(mfUrl).catch(() => undefined));
    }
    const metadataOrUndefined = await Promise.all(promises);
    return metadataOrUndefined.filter((metadata) => metadata !== undefined);
}
exports.fetchAllMetadata = fetchAllMetadata;
async function fetchMetadata(mfUrl) {
    const metaDataResponse = await fetch((0, url_resolver_1.getMetadataUrl)((0, url_resolver_1.resolveUrl)(mfUrl)));
    return await metaDataResponse.json();
}
